import React, { Component } from 'react'
import { Router } from 'react-static'
import { hot } from 'react-hot-loader'
//
import Routes from 'react-static-routes'

import './styles/framework/framework.scss'
import './app.scss'

import { handleWindowResize } from 'utils/helpers'

class App extends Component {

  componentWillMount() {
    handleWindowResize();
  }

  componentDidMount() {
    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);
    window.addEventListener('deviceorientation', handleWindowResize);
  }

  render() {
    return (
      <Router>
        <div>
          <div className="content">
            <Routes/>
          </div>
        </div>
      </Router>
    )
  }
}

export default hot(module)(App)



// WEBPACK FOOTER //
// /usr/src/app/src/App.js